import spinnerAnimation from "../../assets/lottie/loading_logo.json";
import { Lottie } from "components/lottie";
import React from "react";

export const DoorLoopLoader = () => {
  return (
    <Lottie pathColor={"blue"} autoPlay={true} loop={true} animationData={spinnerAnimation} width={70} height={70} />
  );
};
